























































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Marker } from '@/models/Retailer';
import { mapMutations } from 'vuex';
import http from '@/services/Http';
import { MarkersStore } from '@/store/markersstate';
import GenericSearch from '../Blocks/BookMeetingFlow/GenericSearch.vue';
import SelectedItem from '../Blocks/BookMeetingFlow/SelectedItem.vue';
import { Retailer } from '@/models/BookMeetingFlow.js';

@Component({
    components: {
        GenericSearch,
        SelectedItem
    }
})
export default class RetailerSearchBox extends Vue {
    @Prop()
    protected showFilter!: boolean;
    @Prop()
    protected currentCulture!: string;

    protected searchQuery: string = this.getQuerystring('q');
    protected searched: boolean = false;
    protected showFilterSelection: boolean = false;
    protected t: any = null;
    protected gaggenau: string = this.getQuerystring('gaggenau');
    selectedRetailer: Retailer | null = null;

    constructor() {
        super();
    }

    mounted() {
        if (this.showFilter) {
            this.search();
        }
    }

    private openMeetingModal(marker: Marker): void {
        this.selectedRetailer = {
            name: marker.name || '',
            address1: marker.address1 || null,
            zip: marker.zip || null,
            postalAddress: marker.postalAddress || null,
            phone: marker.phone || null,
            openingHours: marker.openingHours || null,
            position: marker.position,
            organizationType: null,
            organizationSystemId: marker.organizationId || null,
            // The server decides which solution the retailer is on and hands over the matching
            // data — old booking links only for the old solution, types only for the new one.
            bookMeetingUrlStore: marker.bookMeetingUrlStore || null,
            bookMeetingUrlHome: marker.bookMeetingUrlHome || null,
            bookMeetingUrlVideo: marker.bookMeetingUrlVideo || null,
            contactPageUrl: null,
            useNewMeetingBooking: !!marker.useNewMeetingBooking,
            distance: null,
            availableMeetingTypes: marker.availableMeetingTypes || [],
        };
        this.$nextTick(() => {
            window.dispatchEvent(new Event('open-meeting-modal'));
        });
    }
    
    private search() {
        const markers: Marker[] = [];
        const query = this.searchQuery ? this.searchQuery.trim() : '';
        this.searchQuery = query;
        this.setQuerystrings('q', this.searchQuery);
        const retailers = http.get(
            `/api/retailer?query=${this.searchQuery}&t=${this.t}&gaggenau=${this.gaggenau}&pagesize=all&exclude=true`
        );

        retailers.then((response: any) => {
            const data = response.json();
            
            data.then((retailerList: any[]) => {
                retailerList.forEach((item: Marker) => {
                    if (
                        item != null &&
                        item.position != null &&
                        item.position.lat != null &&
                        item.position.lng != null
                    ) {
                        markers.push(item);
                    } else {
                        //   console.log(item.name + ' is missing position');
                    }
                });
                MarkersStore.searchRetailer(markers);
                this.searched = this.shouldDisplaySearchResults(this.searchQuery, markers);
            }).catch((e: any) => {
                console.error(e);
            });
        });
    }

    public updateSearchQuery(query: string) {
        this.searchQuery = query;
    }

    public submitSearch(query: string) {
        this.searchQuery = query;
        this.search();
    }

    public clearSearch() {
        this.searchQuery = '';
        this.search();
    }

    private selectRetailer(index: number) {
        const selectedMarker = this.filteredMapMarkers[index];
        if (!selectedMarker) {
            return;
        }

        this.mapMarkers.forEach(marker => {
            marker.selected = false;
        });

        const storeMarker = this.mapMarkers.find(marker => marker === selectedMarker);
        if (storeMarker) {
            storeMarker.selected = true;
            this.$emit('clicked', storeMarker, this.mapMarkers.indexOf(storeMarker));
        }
    }

    private toggleFilter() {
        this.showFilterSelection = !this.showFilterSelection;
    }

    private shouldDisplaySearchResults(searchQuery: string, markers: Marker[]): boolean {
        return searchQuery.length > 0 || markers.length > 0;
    }

    @Watch('mapMarkers')
    private hasSearched() {
        this.searched = this.shouldDisplaySearchResults(this.searchQuery, this.mapMarkers);
    }

    get mapMarkers(): Marker[] {
        return MarkersStore.getMarkers;
    }

    get filteredMapMarkers(): Marker[] {
        const routeQuery = this.getQuerystring('q');
        if (routeQuery) {
            return this.mapMarkers;
        }

        const query = (this.searchQuery || '').trim().toLowerCase();

        if (!query) {
            return this.mapMarkers;
        }

        return this.mapMarkers.filter((marker: Marker) => {
            const searchableText = [
                marker.name,
                marker.city,
                marker.address1,
                marker.postalAddress,
                marker.zip,
                marker.productCategory
            ]
                .filter((value): value is string => !!value)
                .join(' ')
                .toLowerCase();

            return searchableText.includes(query);
        });
    }

    private setQuerystrings(att: string, value?: string) {
        let currentQuery = JSON.parse(JSON.stringify(this.$route.query));

        if ((value == null || value == undefined || value == '') && currentQuery[att] != undefined) {
            delete currentQuery[att];
        } else if (value != null && value != undefined && value != '') {
            currentQuery[att] = value;
        }

        const route = {
            path: this.$route.params[0],
            query: currentQuery
        };

        this.$router.replace(route, () => {});
    }

    private getQuerystring(guerystring: string): string {
        if (this.$route.query[guerystring] != null && typeof this.$route.query[guerystring] == 'string') {
            return this.$route.query[guerystring] as string;
        }
        return '';
    }
}
